import { Person } from '@/entities/Person/Person'
import { transformToGenderType, transformToIdentificationType } from '@/entities/Person/PersonTransformers'
import { PersonResource } from '@/models/Person'
import { CompanyMedicType } from '@/types'

export const transformLegacyPersonResourceToPacoPerson = (resource: PersonResource): Person => ({
    id: resource.id,
    firstname: resource.firstname,
    affix: resource.affix || undefined,
    lastname: resource.lastname,
    gender: transformToGenderType(resource.gender),
    birthday: resource.birthday ? new Date(resource.birthday) : undefined,
    hasSundayAllowance: resource.hasSundayAllowance,
    identificationExpirationDate: new Date(resource.identificationExpirationDate),
    identificationType: transformToIdentificationType(resource.identificationType),
    companyMedic: resource.isCompanyMedic || CompanyMedicType.unknown,
    nationality: resource.nationality,
    workdays: resource.workDays,
})
